import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const FieldsOfStudyTable = ({
    fieldsOfStudy,
    setSelectedFieldsOfStudy,
    setSelectedFieldsOfStudyTitle,
    loading,
    editOnClick,
    createOnClick,
    previewOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.fieldsOfStudyID} item={item} deleteOnClick={deleteOnClick} />
            ),
        },
        {
            name: 'FieldsOfStudyID',
            fieldName: 'fieldsOfStudyID',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Name',
            fieldName: 'name',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'DetailedName',
            fieldName: 'detailedName',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
    ];

    const items = fieldsOfStudy ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedFieldsOfStudy(selectedItem && selectedItem.fieldsOfStudyID);
        setSelectedFieldsOfStudyTitle?.(selectedItem?.name || selectedItem?.detailedName || "");
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'name'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Field of Study"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Fields Of Study"
                summary="This table displays all fields of study, including their name and detailed name. You can add, edit, or delete fields of study. The Fields of Study feature allows admins to manage academic categories for scholarships and reporting."
                imageUrlPath='field-of-study'
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, item?.name || item?.detailedName || item?.slug || ""),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default FieldsOfStudyTable;
